import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import { IoTrash } from 'react-icons/io5';
import { addAddress, deleteAddress, getAddress } from '../../Services/ProfileServices';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import Loader from '../Main/Loader';
import useMyAddress from '../../Hooks/MyProfile/useMyAddress';

const MyAddressTab = () => {

    const {
        selectedAddress,
        setSelectedAddress,
        isAddnewAddress,
        isLoading,
        allAddress,
        hanldeAddressLine1,
        hanldeAddressLine2,
        hanldeCity,
        hanldeState,
        hanldeCountry,
        hanldeZip,
        handleSubmit,
        handleDeleteAddress,
        setIsAddnewAddress,
        addressLine1,
        addressLine2,
        city,
        state,
        country,
        zip,
        handleEditAddress,
        editAddress
    } = useMyAddress();



    return (
        <Fragment >
            <h5 className='fw-600 border-bottom pb-3'>My Address</h5>

            {isAddnewAddress === 0 && (
                <>
                    {
                        Array.isArray(allAddress) && allAddress?.length > 0 ? (
                            allAddress.map((address, index) => (
                                <Card
                                    key={address}
                                    className={`mb-3 bg-light border-0 ${selectedAddress === address ? "border-primary" : ""}`}
                                >
                                    <Card.Body className="d-flex align-items-start">
                                        <Form.Check
                                            type="radio"
                                            name="address"
                                            id={address}
                                            checked={selectedAddress === address}
                                            onChange={() => setSelectedAddress(address)}
                                            className="me-2"
                                        />
                                        <div className="col-auto verticle-border-70 ms-3" />

                                        <div className='ms-4 w-100'>

                                            <div className="row">
                                                <div className="col">
                                                    <Card.Title className='fw-500'>{`Address ${index + 1}`}</Card.Title>

                                                </div>
                                                <div className="col-auto d-flex">
                                                    <p className='me-2 text-danger fw-600 mb-0 s-14 cursor-pointer' onClick={() => handleEditAddress(address)}>Edit</p>

                                                    <div className="verticle-border" />

                                                    <p className='ms-2 s-14 mb-0 text-muted'>Set As Default</p>
                                                </div>
                                            </div>
                                            <Card.Text>
                                                {address?.street}

                                                <p className='mb-0 text-danger text-end'>

                                                    {
                                                        isLoading ? <Loader /> :
                                                            <>
                                                                <IoTrash className='cursor-pointer' size={18} onClick={() => { handleDeleteAddress(address?.id) }} />

                                                            </>
                                                    }
                                                </p>

                                            </Card.Text>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))
                        ) : ("No Address")

                    }

                    < div >
                        <button
                            type='button'
                            onClick={() => setIsAddnewAddress(1)}
                            className='btn px-4 py-2 rounded-3 btn-danger'>
                            Add New Address
                        </button>
                    </div>
                </>

            )
            }


            {
                isAddnewAddress === 1 &&
                (
                    <>
                        <Form onSubmit={handleSubmit} className='row'>
                            <Form.Group className="mb-3 col-lg-12 mt-3">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Address Line 1"
                                    value={addressLine1}
                                    onChange={hanldeAddressLine1}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-12">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Address Line 2"
                                    value={addressLine2}
                                    onChange={hanldeAddressLine2}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="City"
                                    value={city}
                                    onChange={hanldeCity}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="State"
                                    value={state}
                                    onChange={hanldeState}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Country"
                                    value={country}
                                    onChange={hanldeCountry}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="ZIP"
                                    value={zip}
                                    onChange={hanldeZip}
                                />
                            </Form.Group>

                            <div>
                                <button
                                    type="submit"
                                    className='mb-3 btn btn-danger px-4 py-2'
                                >
                                    {isLoading ? <Loader /> : "Submit"}

                                </button>
                            </div>
                        </Form >
                    </>
                )
            }

            {/* {
                isAddnewAddress === "editAddress" &&
                (
                    <>
                        <Form onSubmit={handleEdit} className='row'>
                            <Form.Group className="mb-3 col-lg-12 mt-3">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Address Line 1"
                                    value={addressLine1}
                                    onChange={hanldeAddressLine1}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="City"
                                    value={city}
                                    onChange={hanldeCity}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="State"
                                    value={state}
                                    onChange={hanldeState}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Country"
                                    value={country}
                                    onChange={hanldeCountry}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="ZIP"
                                    value={zip}
                                    onChange={hanldeZip}
                                />
                            </Form.Group>

                            <div>
                                <button
                                    type="submit"
                                    className='mb-3 btn btn-danger px-4 py-2'
                                >
                                    Save Changes
                                </button>
                            </div>
                        </Form >
                    </>
                )
            } */}





        </Fragment >
    )
}

export default MyAddressTab;
